// Store page extension (admin side): what the product page shows about the
// product. The tab is the old catalog editor's Store Page tab, reused as it is.
import { BuildingStorefrontIcon } from "@heroicons/react/24/outline"
import StorePageTab from "./StorePageTab"
import { CatalogEditorProvider, catalogSection, catalogVisible, useCatalogVisibilityContext } from "../shared/catalog-editor"
import { adminOnly, useVendorVisibilityContext } from "../shared/vendor-visibility"

export const StoreProductExtension = {
  id: "store-page",
  label: "Store Page",
  description: "The fields the product page shows (publisher, publish date, language, pages, year, cover type)",
  section: {
    component: catalogSection(StorePageTab),
    label: "Store Page",
    icon: BuildingStorefrontIcon,
    order: 620,
    // which rows the page shows is Aldoo's: a merchant's product follows its
    // content type's (an empty list does, see StorePageTab)
    visible: adminOnly(catalogVisible("store")),
  },
  provider: CatalogEditorProvider,
  visibilityContext: [useCatalogVisibilityContext, useVendorVisibilityContext],
}
